import { pluralizeDays } from 'shared/lib/pluralize';
import type { TPreparedVitrinsCreditCard } from 'shared/types/TVitrinsService';
import { VITRINS_OFFER_CARD_TEXTS } from 'shared/ui/VitrinsOffersCard';

export const buildCreditCardSummary = (offer: TPreparedVitrinsCreditCard) => {
  return [
    {
      label: VITRINS_OFFER_CARD_TEXTS.GRACE_PERIOD,
      value: offer.gracePeriod ? `${offer.gracePeriod} ${pluralizeDays(offer.gracePeriod)}` : '',
    },
    {
      label: VITRINS_OFFER_CARD_TEXTS.CARD_LIMIT,
      value: offer.creditLimit ?? '',
    },
    {
      label: VITRINS_OFFER_CARD_TEXTS.MAINTENANCE,
      value: offer.maintenancePrice ?? '',
    },
  ].filter(({ value }) => Boolean(value));
};
